import fetch from './index';

// -----------------IP-REPORT IP地址统计
// 获取IP地址统计
const getList = (params: Object) => fetch.axios_admin.get('statistics/messageRemind/loginIp/condition', { params });

export default {
  getList,
};
